module.exports = function () {
  return {
    $get: [
      function () {
        const callSync = function (path) {
          const xhr = new XMLHttpRequest()
          let content = ''
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              if (xhr.status === 200 || xhr.status === 304 || xhr.status === 202 || xhr.status === 0) {
                content = xhr.responseText
              }
            }
          }

          xhr.open('GET', path + '?_t=' + new Date().valueOf(), false)
          xhr.send()

          return content
        }

        return {
          /**
           * 在 runtime 阶段加载 json 文件，并在文件不存在的时候返回空对象
           * load json files at run time, which will return empty object when the file does not exist
           * @param path
           * @returns {{}}
           */
          loadJSON: function (path) {
            /** load JSON files */
            if (/\.json$/gi.test(path)) {
              const content = callSync(path)
              try {
                return JSON.parse(
                  content.replace(/\\u2028/g, '\\\\u2028')
                    .replace(/\\u2029/g, '\\\\u2029'))
              } catch (e) {
                console.log('Failed to convert invalid configuration file. path: ' + path)
                return {}
              }
            }

            return {}
          },

          /**
           * 为了兼容某些浏览器，需要重新检查一遍样式的完整内容
           * @param path
           */
          loadCSS: function (path) {
            /** load CSS files */
            if (/\.css/gi.test(path)) {
              return callSync(path)
            }

            return ''
          }
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/loadSync.js